// Badge types for card titles - using const since HubSpot doesn't use enums
export const TITLE_BADGE_TYPES = {
  NEW: 'NEW',
  BETA: 'BETA'
};